import * as moment from 'moment';
import axios from 'axios'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import Status from '../../../../config/OrderStatusConstants.js'
import { serverIp } from '../../../../config/constants.js'



export function sendDesignChatActionToSlack(designChatUrl, designChatAction) {
    console.log("dsc73 slack12 +++++++ sendDesignChatActionToSlack");
    console.log("dsc74 slack13 designChatUrl:" + designChatUrl);
    console.log("dsc741 slack13 designChatAction:" + designChatAction);

    axios.post(serverIp + 'slackNotifs/sendDesignChatNotif', {
        apiKey: "-LTS8qkgryCp2DScxtJO",
        phonePlusUserFbKey: designChatUrl,
        designChatAction: designChatAction
    })
        .then((response) => {
            console.log("dsc76 responce:"+response.data);

            if (response.data) {
                console.log("dsc75 sms send reply:" + JSON.stringify(response.data, null, 3));

            } else {
                console.log("dsc76 ERROR:");
                alert("ERROR:" + JSON.stringify(response.data, null, 3));
            }
        })
        .catch((error) => {
            console.log(error);
        });

}

export function updateToClientRejected(orderKey, adminEmail, rejectedReason) {

    console.log("+++++++: updateToClientRejected");

    let newTime = new Date().getTime();
    let now = moment().format('MMMM Do YYYY, h:mm:ss a');
    let orderUpdates = {
        status: Status.clnt_rejectd_dsgn,
        rejectedReason: rejectedReason,
        rejectedTime: newTime,
        lastUpdated: now,
        lastUpdatedBy: adminEmail
        // udpatedBy: this.props.user.email
    }

    FbUtils.updateOrder(orderKey, orderUpdates);

}

export function updateToClientApproved(orderKey, adminEmail) {

    console.log("+++++++: updateToClientApproved");

    let newTime = new Date().getTime();
    let now = moment().format('MMMM Do YYYY, h:mm:ss a');
    let orderUpdates = {
        status: Status.clnt_apprvd_dsgn,
        // rejectedReason:rejectedReason,
        clnt_apprvdTime: newTime,
        lastUpdated: now,
        lastUpdatedBy: adminEmail
        // udpatedBy: this.props.user.email
    }

    FbUtils.updateOrder(orderKey, orderUpdates);

}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Utils/StatusUpdateUtils.js